export default "__VITE_PUBLIC_ASSET__63fe11f7__"